var strings = {
    vi: {
        title: 'Khởi tạo doanh nghiệp',
        identity_industry: 'Ngành',
        round_unlocks: 'Mở thêm:',
        round_locked: 'Bắt buộc cho ngành này',
        cta_back: 'Quay lại',
        cta_skip: 'Bỏ qua',
        cta_continue: 'Tiếp tục',
        loading: 'Đang xử lý...',
        error_generic: 'Đã xảy ra lỗi',
        apply_failed: 'Chưa thể áp dụng cấu hình. Dữ liệu đã chọn vẫn được giữ lại.',
        retry: 'Thử lại',
        progress_question: 'Câu',
        question_eyebrow: 'THIẾT LẬP NHANH',
        answer_yes: 'Có',
        answer_no: 'Không',
        logout: 'Đăng xuất',
        feature_label: 'Tính năng',
        detail_toggle: 'Nên chọn thế nào?',
        detail_changeable: 'Đổi lại được bất cứ lúc nào trong Cài đặt.',
        need_answer: 'Hãy chọn một đáp án để tiếp tục',
        areas_need_row: 'Cần ít nhất 1 dòng, hoặc chọn Không.',
        areas_need_valid: 'Cần ít nhất 1 dòng hợp lệ.',
        list_rooms: 'Danh sách phòng',
        list_fields: 'Danh sách sân',
        list_seats: 'Danh sách ghế',
        list_table_areas: 'Danh sách khu vực bàn',
        create_rooms: 'Tạo phòng',
        create_fields: 'Tạo sân',
        create_tables: 'Tạo mới',
        cta_confirm: 'Xác nhận',
        areas_need_area: 'Cần ít nhất một khu vực hợp lệ.',
        p_area_name_required: 'Cần nhập tên khu vực',
        p_prefix_required: 'Cần nhập tiền tố',
        p_start_min: 'Số bắt đầu phải ≥ 1',
        p_end_min: 'Số kết thúc phải ≥ số bắt đầu',
        p_count_range: 'Số lượng phải từ {min} đến {max}',
        p_range_overlap: 'Khoảng số chồng với dòng khác (cùng tiền tố)',
        p_range_invalid: 'Vui lòng nhập khoảng số hợp lệ.',
        p_zone_n: 'Khu {n}',
        p_area: 'Khu vực',
        p_prefix: 'Tiền tố',
        p_start: 'Bắt đầu',
        p_end: 'Kết thúc',
        p_start_short: 'Số đầu',
        p_end_short: 'Số cuối',
        p_count: 'Số lượng',
        p_none: '(không)',
        p_add_row: 'Thêm dòng',
        p_total: 'Tổng',
        p_min_max: 'tối thiểu {min}, tối đa {max} mỗi dòng',
        p_unit_rooms: 'phòng',
        p_unit_fields: 'sân',
        p_unit_seats: 'ghế',
        p_unit_tables: 'bàn',
        p_range_unset: 'Chưa thiết lập dải số',
        p_quantity: 'Số lượng',
        p_number_range: 'Dải số',
        p_add_area: 'Thêm khu vực',
        p_rooms_to_create: 'Số phòng sẽ tạo',
        p_fields_to_create: 'Số sân sẽ tạo',
        p_seats_to_create: 'Số ghế sẽ tạo',
        p_tables_to_create: 'Số bàn sẽ tạo',
        p_name_required: 'Cần nhập tên',
        p_name_too_long: 'Tên quá dài (≤ 250)',
        p_price_invalid: 'Giá không hợp lệ',
        p_add_or_skip: 'Thêm ít nhất 1 dòng hoặc bỏ qua',
        p_samples_added: 'Đã thêm {n} sản phẩm mẫu. Hãy xem lại trước khi tiếp tục.',
        p_rate_limit: 'Bạn thao tác quá nhanh. Vui lòng chờ một phút.',
        p_ai_quota: 'Đã hết hạn mức AI hoặc nhà cung cấp hiện không khả dụng.',
        p_sample_failed: 'Không tạo được dữ liệu mẫu. Vui lòng thử lại.',
        p_file_too_large: 'File quá lớn (tối đa 10MB)',
        p_image_too_large: 'Có file vượt quá giới hạn (ảnh tối đa 10 MB). Vui lòng chọn file nhỏ hơn.',
        p_file_unsupported: 'Chỉ hỗ trợ ảnh / PDF / Excel / CSV',
        p_ai_read_failed: 'AI không đọc được, vui lòng nhập tay hoặc thử file khác',
        p_ai_empty_plan: 'AI không trích xuất được, thử file rõ hơn',
        p_ai_disabled: 'Tính năng AI chưa được cấu hình',
        p_col_name: 'Tên sản phẩm',
        p_col_group: 'Nhóm',
        p_col_price: 'Giá bán',
        p_drop_products: 'Kéo thả file (ảnh / PDF / Excel / Word / CSV, ≤ 10MB) — AI sẽ đọc và thêm vào danh sách',
        p_drop_slots: 'Kéo thả bảng giá (ảnh / PDF / Excel / CSV, ≤ 10MB) — AI sẽ trích xuất khung giờ',
        p_reading_file: 'Đang đọc file…',
        p_pick_file: 'hoặc bấm để chọn file',
        p_sample: 'Tạo dữ liệu mẫu',
        p_sample_hint: 'Dữ liệu mẫu giúp bạn dùng thử tính năng, có thể dọn dẹp sau.',
        p_generating: 'Đang tạo dữ liệu mẫu…',
        p_sample_images: 'Ảnh sản phẩm mẫu được tạo sau khi lưu.',
        p_items_added: 'Đã thêm {n} mục mới.',
        p_items_added_skipped: 'Đã thêm {n} mục mới, bỏ qua {m} mục đã có.',
        p_added_to_list: 'Đã thêm {name} vào danh sách.',
        p_act_add: 'Thêm',
        p_act_camera: 'Chụp',
        p_act_gallery: 'Ảnh',
        p_act_text: 'Văn bản',
        p_act_device: 'Thiết bị',
        p_review_ai: 'Kiểm tra kết quả AI',
        p_items_found: '{n} mục được tìm thấy',
        p_menu: 'Thực đơn',
        p_all: 'Tất cả',
        p_added_badge: 'ĐÃ THÊM',
        p_confirm_add: 'Xác nhận thêm',
        p_auto_images: 'Tự động tạo hình ảnh sản phẩm',
        p_slot_code_required: 'Cần nhập mã khung giờ',
        p_hour_invalid: 'Giờ không hợp lệ (HH:MM:SS)',
        p_hour_range: 'Giờ kết thúc phải sau giờ bắt đầu',
        p_col_code: 'Mã',
        p_col_slot_name: 'Tên',
        p_col_start: 'Giờ bắt đầu',
        p_col_end: 'Giờ kết thúc',
        p_col_weekday: 'Giá thường',
        p_col_weekend: 'Giá cuối tuần',
        p_add_slot: 'Thêm khung giờ',
        p_currency: 'Tiền tệ'
    },
    en: {
        title: 'Setup your business',
        identity_industry: 'Industry',
        round_unlocks: 'Unlocks:',
        round_locked: 'Required for this industry',
        cta_back: 'Back',
        cta_skip: 'Skip',
        cta_continue: 'Continue',
        loading: 'Processing...',
        error_generic: 'An error occurred',
        apply_failed: 'The configuration could not be applied. Your selections are still saved.',
        retry: 'Try again',
        progress_question: 'Question',
        question_eyebrow: 'QUICK SETUP',
        answer_yes: 'Yes',
        answer_no: 'No',
        logout: 'Sign out',
        feature_label: 'Feature',
        detail_toggle: 'Which should I choose?',
        detail_changeable: 'You can change this anytime in Settings.',
        need_answer: 'Pick an answer to continue',
        areas_need_row: 'Add at least one row, or answer No.',
        areas_need_valid: 'Add at least one valid row.',
        list_rooms: 'Room list',
        list_fields: 'Court list',
        list_seats: 'Seat list',
        list_table_areas: 'Table areas',
        create_rooms: 'Create rooms',
        create_fields: 'Create courts',
        create_tables: 'Create tables',
        cta_confirm: 'Confirm',
        areas_need_area: 'Add at least one valid area.',
        p_area_name_required: 'Area name required',
        p_prefix_required: 'Prefix required',
        p_start_min: 'Start no. must be ≥ 1',
        p_end_min: 'End no. must be ≥ start no.',
        p_count_range: 'Count must be between {min} and {max}',
        p_range_overlap: 'Range overlaps another row (same prefix)',
        p_range_invalid: 'Enter a valid number range.',
        p_zone_n: 'Zone {n}',
        p_area: 'Area',
        p_prefix: 'Prefix',
        p_start: 'Start',
        p_end: 'End',
        p_start_short: 'Start',
        p_end_short: 'End',
        p_count: 'Count',
        p_none: '(none)',
        p_add_row: 'Add row',
        p_total: 'Total',
        p_min_max: 'min {min}, max {max} per row',
        p_unit_rooms: 'rooms',
        p_unit_fields: 'courts',
        p_unit_seats: 'seats',
        p_unit_tables: 'tables',
        p_range_unset: 'Number range not set',
        p_quantity: 'Quantity',
        p_number_range: 'Number range',
        p_add_area: 'Add area',
        p_rooms_to_create: 'Rooms to create',
        p_fields_to_create: 'Courts to create',
        p_seats_to_create: 'Seats to create',
        p_tables_to_create: 'Tables to create',
        p_name_required: 'Name required',
        p_name_too_long: 'Name too long (≤ 250)',
        p_price_invalid: 'Invalid price',
        p_add_or_skip: 'Add at least one row or skip',
        p_samples_added: 'Added {n} sample products. Review before continuing.',
        p_rate_limit: 'Too many requests. Please wait a minute.',
        p_ai_quota: 'AI quota is exhausted or the provider is unavailable.',
        p_sample_failed: 'Could not generate sample data. Please try again.',
        p_file_too_large: 'File too large (max 10MB)',
        p_image_too_large: 'A file exceeds the allowed limit (10 MB for images). Please choose a smaller file.',
        p_file_unsupported: 'Only image / PDF / Excel / CSV supported',
        p_ai_read_failed: 'AI could not read it; please type manually or try another file',
        p_ai_empty_plan: 'AI could not extract anything; try a clearer file',
        p_ai_disabled: 'AI is not configured',
        p_col_name: 'Product name',
        p_col_group: 'Group',
        p_col_price: 'Sale price',
        p_drop_products: 'Drop a file (image / PDF / Excel / Word / CSV, ≤ 10MB) — AI will read it and add to the list',
        p_drop_slots: 'Drop a price sheet (image / PDF / Excel / CSV, ≤ 10MB) — AI will extract the time slots',
        p_reading_file: 'Reading file…',
        p_pick_file: 'or click to pick a file',
        p_sample: 'Generate sample data',
        p_sample_hint: 'Sample data helps you try features. You can clean it up later.',
        p_generating: 'Generating sample data…',
        p_sample_images: 'Sample images are generated after saving.',
        p_items_added: 'Added {n} new items.',
        p_items_added_skipped: 'Added {n} new items; skipped {m} existing.',
        p_added_to_list: 'Added {name}.',
        p_act_add: 'Add',
        p_act_camera: 'Camera',
        p_act_gallery: 'Gallery',
        p_act_text: 'Text',
        p_act_device: 'Device',
        p_review_ai: 'Review AI results',
        p_items_found: '{n} items found',
        p_menu: 'Menu',
        p_all: 'All',
        p_added_badge: 'ADDED',
        p_confirm_add: 'Confirm and add',
        p_auto_images: 'Auto-generate product images',
        p_slot_code_required: 'Slot code required',
        p_hour_invalid: 'Invalid time (HH:MM:SS)',
        p_hour_range: 'End must be after start',
        p_col_code: 'Code',
        p_col_slot_name: 'Name',
        p_col_start: 'Start time',
        p_col_end: 'End time',
        p_col_weekday: 'Regular price',
        p_col_weekend: 'Weekend price',
        p_add_slot: 'Add time slot',
        p_currency: 'Currency'
    },
    fr: {
        cta_back: 'Retour', cta_continue: 'Continuer', loading: 'Traitement...', error_generic: 'Une erreur est survenue',
        apply_failed: 'La configuration n’a pas pu être appliquée. Vos choix sont conservés.', retry: 'Réessayer', logout: 'Déconnexion',
        progress_question: 'Question', question_eyebrow: 'CONFIGURATION RAPIDE', answer_yes: 'Oui', answer_no: 'Non',
        feature_label: 'Fonctionnalité',
        identity_industry: 'Secteur',
        cta_skip: 'Passer',
        detail_toggle: 'Que choisir ?',
        detail_changeable: 'Modifiable à tout moment dans les Paramètres.',
        need_answer: 'Choisissez une réponse pour continuer',
        areas_need_row: 'Ajoutez au moins une ligne, ou répondez Non.',
        areas_need_valid: 'Ajoutez au moins une ligne valide.',
        list_rooms: 'Liste des salles',
        list_fields: 'Liste des terrains',
        list_seats: 'Liste des places',
        list_table_areas: 'Zones de tables',
        create_rooms: 'Créer les salles',
        create_fields: 'Créer les terrains',
        create_tables: 'Créer les tables',
        cta_confirm: 'Confirmer',
        areas_need_area: 'Ajoutez au moins une zone valide.',
        p_area_name_required: 'Nom de la zone requis',
        p_prefix_required: 'Préfixe requis',
        p_start_min: 'Le n° de début doit être ≥ 1',
        p_end_min: 'Le n° de fin doit être ≥ au n° de début',
        p_count_range: 'La quantité doit être comprise entre {min} et {max}',
        p_range_overlap: 'La plage chevauche une autre ligne (même préfixe)',
        p_range_invalid: 'Veuillez saisir une plage de numéros valide.',
        p_zone_n: 'Zone {n}',
        p_area: 'Zone',
        p_prefix: 'Préfixe',
        p_start: 'Début',
        p_end: 'Fin',
        p_start_short: 'Début',
        p_end_short: 'Fin',
        p_count: 'Quantité',
        p_none: '(aucun)',
        p_add_row: 'Ajouter une ligne',
        p_total: 'Total',
        p_min_max: 'min. {min}, max. {max} par ligne',
        p_unit_rooms: 'salles',
        p_unit_fields: 'terrains',
        p_unit_seats: 'sièges',
        p_unit_tables: 'tables',
        p_range_unset: 'Plage de numéros non définie',
        p_quantity: 'Quantité',
        p_number_range: 'Plage de numéros',
        p_add_area: 'Ajouter une zone',
        p_rooms_to_create: 'Salles à créer',
        p_fields_to_create: 'Terrains à créer',
        p_seats_to_create: 'Sièges à créer',
        p_tables_to_create: 'Tables à créer',
        p_name_required: 'Nom requis',
        p_name_too_long: 'Nom trop long (≤ 250)',
        p_price_invalid: 'Prix non valide',
        p_add_or_skip: 'Ajoutez au moins une ligne ou passez cette étape',
        p_samples_added: '{n} produits exemples ajoutés. Vérifiez-les avant de continuer.',
        p_rate_limit: 'Trop de requêtes. Veuillez patienter une minute.',
        p_ai_quota: 'Le quota AI est épuisé ou le fournisseur est indisponible.',
        p_sample_failed: 'Impossible de générer les données exemples. Veuillez réessayer.',
        p_file_too_large: 'Fichier trop volumineux (max. 10MB)',
        p_image_too_large: 'Un fichier dépasse la limite autorisée (10 MB pour les images). Veuillez choisir un fichier plus petit.',
        p_file_unsupported: 'Seuls les formats image / PDF / Excel / CSV sont pris en charge',
        p_ai_read_failed: 'AI n\'a pas pu lire le fichier, veuillez saisir manuellement ou essayer un autre fichier',
        p_ai_empty_plan: 'AI n\'a rien pu extraire, essayez un fichier plus net',
        p_ai_disabled: 'AI n\'est pas configurée',
        p_col_name: 'Nom du produit',
        p_col_group: 'Groupe',
        p_col_price: 'Prix de vente',
        p_drop_products: 'Déposez un fichier (image / PDF / Excel / Word / CSV, ≤ 10MB) — AI le lira et l\'ajoutera à la liste',
        p_drop_slots: 'Déposez une grille tarifaire (image / PDF / Excel / CSV, ≤ 10MB) — AI en extraira les créneaux horaires',
        p_reading_file: 'Lecture du fichier…',
        p_pick_file: 'ou cliquez pour choisir un fichier',
        p_sample: 'Générer des données exemples',
        p_sample_hint: 'Les données exemples vous permettent d\'essayer les fonctions. Vous pourrez les supprimer plus tard.',
        p_generating: 'Génération des données exemples…',
        p_sample_images: 'Les images exemples sont générées après l\'enregistrement.',
        p_items_added: '{n} nouveaux éléments ajoutés.',
        p_items_added_skipped: '{n} nouveaux éléments ajoutés, {m} déjà existants ignorés.',
        p_added_to_list: '{name} ajouté à la liste.',
        p_act_add: 'Ajouter',
        p_act_camera: 'Photo',
        p_act_gallery: 'Galerie',
        p_act_text: 'Texte',
        p_act_device: 'Appareil',
        p_review_ai: 'Vérifier les résultats AI',
        p_items_found: '{n} éléments trouvés',
        p_menu: 'Menu',
        p_all: 'Tout',
        p_added_badge: 'AJOUTÉ',
        p_confirm_add: 'Confirmer l\'ajout',
        p_auto_images: 'Générer automatiquement les images des produits',
        p_slot_code_required: 'Code du créneau requis',
        p_hour_invalid: 'Heure non valide (HH:MM:SS)',
        p_hour_range: 'L\'heure de fin doit être postérieure à l\'heure de début',
        p_col_code: 'Code',
        p_col_slot_name: 'Nom',
        p_col_start: 'Heure de début',
        p_col_end: 'Heure de fin',
        p_col_weekday: 'Prix normal',
        p_col_weekend: 'Prix week-end',
        p_add_slot: 'Ajouter un créneau',
        p_currency: 'Devise'
    },
    es: {
        cta_back: 'Atrás', cta_continue: 'Continuar', loading: 'Procesando...', error_generic: 'Se produjo un error',
        apply_failed: 'No se pudo aplicar la configuración. Sus selecciones se conservaron.', retry: 'Reintentar', logout: 'Cerrar sesión',
        progress_question: 'Pregunta', question_eyebrow: 'CONFIGURACIÓN RÁPIDA', answer_yes: 'Sí', answer_no: 'No',
        feature_label: 'Función',
        identity_industry: 'Sector',
        cta_skip: 'Omitir',
        detail_toggle: '¿Cuál elegir?',
        detail_changeable: 'Puede cambiarlo cuando quiera en Configuración.',
        need_answer: 'Elija una respuesta para continuar',
        areas_need_row: 'Añada al menos una fila o responda No.',
        areas_need_valid: 'Añada al menos una fila válida.',
        list_rooms: 'Lista de salas',
        list_fields: 'Lista de canchas',
        list_seats: 'Lista de asientos',
        list_table_areas: 'Zonas de mesas',
        create_rooms: 'Crear salas',
        create_fields: 'Crear canchas',
        create_tables: 'Crear mesas',
        cta_confirm: 'Confirmar',
        areas_need_area: 'Añada al menos una zona válida.',
        p_area_name_required: 'Nombre del área obligatorio',
        p_prefix_required: 'Prefijo obligatorio',
        p_start_min: 'El n.º inicial debe ser ≥ 1',
        p_end_min: 'El n.º final debe ser ≥ al n.º inicial',
        p_count_range: 'La cantidad debe estar entre {min} y {max}',
        p_range_overlap: 'El rango se superpone con otra fila (mismo prefijo)',
        p_range_invalid: 'Ingrese un rango de números válido.',
        p_zone_n: 'Zona {n}',
        p_area: 'Área',
        p_prefix: 'Prefijo',
        p_start: 'Inicio',
        p_end: 'Fin',
        p_start_short: 'Inicio',
        p_end_short: 'Fin',
        p_count: 'Cantidad',
        p_none: '(ninguno)',
        p_add_row: 'Agregar fila',
        p_total: 'Total',
        p_min_max: 'mín. {min}, máx. {max} por fila',
        p_unit_rooms: 'salas',
        p_unit_fields: 'canchas',
        p_unit_seats: 'asientos',
        p_unit_tables: 'mesas',
        p_range_unset: 'Rango de números sin definir',
        p_quantity: 'Cantidad',
        p_number_range: 'Rango de números',
        p_add_area: 'Agregar área',
        p_rooms_to_create: 'Salas a crear',
        p_fields_to_create: 'Canchas a crear',
        p_seats_to_create: 'Asientos a crear',
        p_tables_to_create: 'Mesas a crear',
        p_name_required: 'Nombre obligatorio',
        p_name_too_long: 'Nombre demasiado largo (≤ 250)',
        p_price_invalid: 'Precio no válido',
        p_add_or_skip: 'Agregue al menos una fila u omita este paso',
        p_samples_added: 'Se agregaron {n} productos de ejemplo. Revíselos antes de continuar.',
        p_rate_limit: 'Demasiadas solicitudes. Espere un minuto.',
        p_ai_quota: 'La cuota de AI se agotó o el proveedor no está disponible.',
        p_sample_failed: 'No se pudieron generar los datos de ejemplo. Inténtelo de nuevo.',
        p_file_too_large: 'Archivo demasiado grande (máx. 10MB)',
        p_image_too_large: 'Un archivo supera el límite permitido (10 MB para imágenes). Elija un archivo más pequeño.',
        p_file_unsupported: 'Solo se admiten imagen / PDF / Excel / CSV',
        p_ai_read_failed: 'AI no pudo leerlo; ingrese los datos manualmente o pruebe con otro archivo',
        p_ai_empty_plan: 'AI no pudo extraer nada; pruebe con un archivo más claro',
        p_ai_disabled: 'AI no está configurada',
        p_col_name: 'Nombre del producto',
        p_col_group: 'Grupo',
        p_col_price: 'Precio de venta',
        p_drop_products: 'Arrastre un archivo (imagen / PDF / Excel / Word / CSV, ≤ 10MB) — AI lo leerá y lo agregará a la lista',
        p_drop_slots: 'Arrastre una lista de precios (imagen / PDF / Excel / CSV, ≤ 10MB) — AI extraerá las franjas horarias',
        p_reading_file: 'Leyendo archivo…',
        p_pick_file: 'o haga clic para elegir un archivo',
        p_sample: 'Generar datos de ejemplo',
        p_sample_hint: 'Los datos de ejemplo le permiten probar las funciones. Podrá eliminarlos más tarde.',
        p_generating: 'Generando datos de ejemplo…',
        p_sample_images: 'Las imágenes de ejemplo se generan después de guardar.',
        p_items_added: 'Se agregaron {n} elementos nuevos.',
        p_items_added_skipped: 'Se agregaron {n} elementos nuevos; se omitieron {m} ya existentes.',
        p_added_to_list: 'Se agregó {name} a la lista.',
        p_act_add: 'Agregar',
        p_act_camera: 'Cámara',
        p_act_gallery: 'Galería',
        p_act_text: 'Texto',
        p_act_device: 'Dispositivo',
        p_review_ai: 'Revisar resultados de AI',
        p_items_found: '{n} elementos encontrados',
        p_menu: 'Menú',
        p_all: 'Todo',
        p_added_badge: 'AGREGADO',
        p_confirm_add: 'Confirmar y agregar',
        p_auto_images: 'Generar imágenes de productos automáticamente',
        p_slot_code_required: 'Código de franja obligatorio',
        p_hour_invalid: 'Hora no válida (HH:MM:SS)',
        p_hour_range: 'La hora de fin debe ser posterior a la de inicio',
        p_col_code: 'Código',
        p_col_slot_name: 'Nombre',
        p_col_start: 'Hora de inicio',
        p_col_end: 'Hora de fin',
        p_col_weekday: 'Precio normal',
        p_col_weekend: 'Precio fin de semana',
        p_add_slot: 'Agregar franja horaria',
        p_currency: 'Moneda'
    },
    id: {
        cta_back: 'Kembali', cta_continue: 'Lanjutkan', loading: 'Memproses...', error_generic: 'Terjadi kesalahan',
        apply_failed: 'Konfigurasi belum dapat diterapkan. Pilihan Anda tetap tersimpan.', retry: 'Coba lagi', logout: 'Keluar',
        progress_question: 'Pertanyaan', question_eyebrow: 'PENGATURAN CEPAT', answer_yes: 'Ya', answer_no: 'Tidak',
        feature_label: 'Fitur',
        identity_industry: 'Industri',
        cta_skip: 'Lewati',
        detail_toggle: 'Pilih yang mana?',
        detail_changeable: 'Bisa diubah kapan saja di Pengaturan.',
        need_answer: 'Pilih jawaban untuk melanjutkan',
        areas_need_row: 'Tambahkan minimal satu baris, atau jawab Tidak.',
        areas_need_valid: 'Tambahkan minimal satu baris yang valid.',
        list_rooms: 'Daftar ruangan',
        list_fields: 'Daftar lapangan',
        list_seats: 'Daftar kursi',
        list_table_areas: 'Area meja',
        create_rooms: 'Buat ruangan',
        create_fields: 'Buat lapangan',
        create_tables: 'Buat meja',
        cta_confirm: 'Konfirmasi',
        areas_need_area: 'Tambahkan minimal satu area yang valid.',
        p_area_name_required: 'Nama area wajib diisi',
        p_prefix_required: 'Awalan wajib diisi',
        p_start_min: 'No. awal harus ≥ 1',
        p_end_min: 'No. akhir harus ≥ no. awal',
        p_count_range: 'Jumlah harus antara {min} dan {max}',
        p_range_overlap: 'Rentang tumpang tindih dengan baris lain (awalan sama)',
        p_range_invalid: 'Masukkan rentang nomor yang valid.',
        p_zone_n: 'Zona {n}',
        p_area: 'Area',
        p_prefix: 'Awalan',
        p_start: 'Awal',
        p_end: 'Akhir',
        p_start_short: 'No. awal',
        p_end_short: 'No. akhir',
        p_count: 'Jumlah',
        p_none: '(tidak ada)',
        p_add_row: 'Tambah baris',
        p_total: 'Total',
        p_min_max: 'min. {min}, maks. {max} per baris',
        p_unit_rooms: 'ruangan',
        p_unit_fields: 'lapangan',
        p_unit_seats: 'kursi',
        p_unit_tables: 'meja',
        p_range_unset: 'Rentang nomor belum diatur',
        p_quantity: 'Jumlah',
        p_number_range: 'Rentang nomor',
        p_add_area: 'Tambah area',
        p_rooms_to_create: 'Ruangan yang dibuat',
        p_fields_to_create: 'Lapangan yang dibuat',
        p_seats_to_create: 'Kursi yang dibuat',
        p_tables_to_create: 'Meja yang dibuat',
        p_name_required: 'Nama wajib diisi',
        p_name_too_long: 'Nama terlalu panjang (≤ 250)',
        p_price_invalid: 'Harga tidak valid',
        p_add_or_skip: 'Tambahkan minimal 1 baris atau lewati',
        p_samples_added: '{n} produk contoh ditambahkan. Periksa kembali sebelum melanjutkan.',
        p_rate_limit: 'Terlalu banyak permintaan. Mohon tunggu satu menit.',
        p_ai_quota: 'Kuota AI habis atau penyedia sedang tidak tersedia.',
        p_sample_failed: 'Gagal membuat data contoh. Silakan coba lagi.',
        p_file_too_large: 'File terlalu besar (maks. 10MB)',
        p_image_too_large: 'Ada file yang melebihi batas (gambar maks. 10 MB). Silakan pilih file yang lebih kecil.',
        p_file_unsupported: 'Hanya mendukung gambar / PDF / Excel / CSV',
        p_ai_read_failed: 'AI tidak dapat membacanya, silakan isi manual atau coba file lain',
        p_ai_empty_plan: 'AI tidak dapat mengekstrak data, coba file yang lebih jelas',
        p_ai_disabled: 'Fitur AI belum dikonfigurasi',
        p_col_name: 'Nama produk',
        p_col_group: 'Grup',
        p_col_price: 'Harga jual',
        p_drop_products: 'Seret file ke sini (gambar / PDF / Excel / Word / CSV, ≤ 10MB) — AI akan membaca dan menambahkannya ke daftar',
        p_drop_slots: 'Seret daftar harga ke sini (gambar / PDF / Excel / CSV, ≤ 10MB) — AI akan mengekstrak slot waktu',
        p_reading_file: 'Membaca file…',
        p_pick_file: 'atau klik untuk memilih file',
        p_sample: 'Buat data contoh',
        p_sample_hint: 'Data contoh membantu Anda mencoba fitur dan dapat dihapus nanti.',
        p_generating: 'Membuat data contoh…',
        p_sample_images: 'Gambar produk contoh dibuat setelah disimpan.',
        p_items_added: '{n} item baru ditambahkan.',
        p_items_added_skipped: '{n} item baru ditambahkan, {m} item yang sudah ada dilewati.',
        p_added_to_list: '{name} ditambahkan ke daftar.',
        p_act_add: 'Tambah',
        p_act_camera: 'Kamera',
        p_act_gallery: 'Galeri',
        p_act_text: 'Teks',
        p_act_device: 'Perangkat',
        p_review_ai: 'Periksa hasil AI',
        p_items_found: '{n} item ditemukan',
        p_menu: 'Menu',
        p_all: 'Semua',
        p_added_badge: 'DITAMBAHKAN',
        p_confirm_add: 'Konfirmasi tambah',
        p_auto_images: 'Buat gambar produk otomatis',
        p_slot_code_required: 'Kode slot waktu wajib diisi',
        p_hour_invalid: 'Waktu tidak valid (HH:MM:SS)',
        p_hour_range: 'Jam selesai harus setelah jam mulai',
        p_col_code: 'Kode',
        p_col_slot_name: 'Nama',
        p_col_start: 'Jam mulai',
        p_col_end: 'Jam selesai',
        p_col_weekday: 'Harga normal',
        p_col_weekend: 'Harga akhir pekan',
        p_add_slot: 'Tambah slot waktu',
        p_currency: 'Mata uang'
    },
    ja: {
        cta_back: '戻る', cta_continue: '続ける', loading: '処理中...', error_generic: 'エラーが発生しました',
        apply_failed: '設定を適用できませんでした。選択内容は保存されています。', retry: '再試行', logout: 'ログアウト',
        progress_question: '質問', question_eyebrow: 'クイック設定', answer_yes: 'はい', answer_no: 'いいえ',
        feature_label: '機能',
        identity_industry: '業種',
        cta_skip: 'スキップ',
        detail_toggle: 'どちらを選ぶ？',
        detail_changeable: '設定でいつでも変更できます。',
        need_answer: '続けるには回答を選んでください',
        areas_need_row: '1行以上追加するか、「いいえ」を選んでください。',
        areas_need_valid: '有効な行を1行以上追加してください。',
        list_rooms: '部屋一覧',
        list_fields: 'コート一覧',
        list_seats: '座席一覧',
        list_table_areas: 'テーブルエリア',
        create_rooms: '部屋を作成',
        create_fields: 'コートを作成',
        create_tables: 'テーブルを作成',
        cta_confirm: '確認',
        areas_need_area: '有効なエリアを1つ以上追加してください。',
        p_area_name_required: 'エリア名を入力してください',
        p_prefix_required: '接頭辞を入力してください',
        p_start_min: '開始番号は ≥ 1 にしてください',
        p_end_min: '終了番号は ≥ 開始番号にしてください',
        p_count_range: '数量は {min}〜{max} の範囲で入力してください',
        p_range_overlap: '番号範囲が他の行と重複しています（同じ接頭辞）',
        p_range_invalid: '有効な番号範囲を入力してください。',
        p_zone_n: 'ゾーン {n}',
        p_area: 'エリア',
        p_prefix: '接頭辞',
        p_start: '開始',
        p_end: '終了',
        p_start_short: '開始番号',
        p_end_short: '終了番号',
        p_count: '数量',
        p_none: '（なし）',
        p_add_row: '行を追加',
        p_total: '合計',
        p_min_max: '1行あたり最小 {min}、最大 {max}',
        p_unit_rooms: '部屋',
        p_unit_fields: 'コート',
        p_unit_seats: '席',
        p_unit_tables: '卓',
        p_range_unset: '番号範囲が未設定です',
        p_quantity: '数量',
        p_number_range: '番号範囲',
        p_add_area: 'エリアを追加',
        p_rooms_to_create: '作成する部屋数',
        p_fields_to_create: '作成するコート数',
        p_seats_to_create: '作成する席数',
        p_tables_to_create: '作成するテーブル数',
        p_name_required: '名前を入力してください',
        p_name_too_long: '名前が長すぎます（≤ 250）',
        p_price_invalid: '価格が正しくありません',
        p_add_or_skip: '1行以上追加するか、スキップしてください',
        p_samples_added: 'サンプル商品を {n} 件追加しました。続行する前にご確認ください。',
        p_rate_limit: '操作が速すぎます。1分ほどお待ちください。',
        p_ai_quota: 'AI の利用上限に達したか、プロバイダーが利用できません。',
        p_sample_failed: 'サンプルデータを作成できませんでした。もう一度お試しください。',
        p_file_too_large: 'ファイルが大きすぎます（最大 10MB）',
        p_image_too_large: '上限を超えるファイルがあります（画像は最大 10 MB）。より小さいファイルを選択してください。',
        p_file_unsupported: '画像 / PDF / Excel / CSV のみ対応しています',
        p_ai_read_failed: 'AI が読み取れませんでした。手入力するか、別のファイルをお試しください',
        p_ai_empty_plan: 'AI が抽出できませんでした。より鮮明なファイルをお試しください',
        p_ai_disabled: 'AI 機能が設定されていません',
        p_col_name: '商品名',
        p_col_group: 'グループ',
        p_col_price: '販売価格',
        p_drop_products: 'ファイルをドラッグ＆ドロップ（画像 / PDF / Excel / Word / CSV、≤ 10MB）— AI が読み取ってリストに追加します',
        p_drop_slots: '料金表をドラッグ＆ドロップ（画像 / PDF / Excel / CSV、≤ 10MB）— AI が時間帯を抽出します',
        p_reading_file: 'ファイルを読み込み中…',
        p_pick_file: 'またはクリックしてファイルを選択',
        p_sample: 'サンプルデータを作成',
        p_sample_hint: 'サンプルデータで機能をお試しいただけます。後から削除できます。',
        p_generating: 'サンプルデータを作成中…',
        p_sample_images: 'サンプル商品画像は保存後に作成されます。',
        p_items_added: '{n} 件を追加しました。',
        p_items_added_skipped: '{n} 件を追加し、既存の {m} 件をスキップしました。',
        p_added_to_list: '{name} をリストに追加しました。',
        p_act_add: '追加',
        p_act_camera: '撮影',
        p_act_gallery: '写真',
        p_act_text: 'テキスト',
        p_act_device: 'デバイス',
        p_review_ai: 'AI の結果を確認',
        p_items_found: '{n} 件見つかりました',
        p_menu: 'メニュー',
        p_all: 'すべて',
        p_added_badge: '追加済み',
        p_confirm_add: '確認して追加',
        p_auto_images: '商品画像を自動作成',
        p_slot_code_required: '時間帯コードを入力してください',
        p_hour_invalid: '時刻が正しくありません（HH:MM:SS）',
        p_hour_range: '終了時刻は開始時刻より後にしてください',
        p_col_code: 'コード',
        p_col_slot_name: '名前',
        p_col_start: '開始時刻',
        p_col_end: '終了時刻',
        p_col_weekday: '通常料金',
        p_col_weekend: '週末料金',
        p_add_slot: '時間帯を追加',
        p_currency: '通貨'
    },
    zh: {
        cta_back: '返回', cta_continue: '继续', loading: '处理中...', error_generic: '发生错误',
        apply_failed: '暂时无法应用配置，您的选择已保存。', retry: '重试', logout: '退出登录',
        progress_question: '问题', question_eyebrow: '快速设置', answer_yes: '是', answer_no: '否',
        feature_label: '功能',
        identity_industry: '行业',
        cta_skip: '跳过',
        detail_toggle: '该怎么选？',
        detail_changeable: '可随时在设置中更改。',
        need_answer: '请选择一个答案以继续',
        areas_need_row: '请至少添加一行，或选择“否”。',
        areas_need_valid: '请至少添加一行有效数据。',
        list_rooms: '房间列表',
        list_fields: '场地列表',
        list_seats: '座位列表',
        list_table_areas: '餐桌区域',
        create_rooms: '创建房间',
        create_fields: '创建场地',
        create_tables: '创建餐桌',
        cta_confirm: '确认',
        areas_need_area: '请至少添加一个有效区域。',
        p_area_name_required: '请输入区域名称',
        p_prefix_required: '请输入前缀',
        p_start_min: '起始编号必须 ≥ 1',
        p_end_min: '结束编号必须 ≥ 起始编号',
        p_count_range: '数量必须在 {min} 到 {max} 之间',
        p_range_overlap: '编号范围与其他行重叠（前缀相同）',
        p_range_invalid: '请输入有效的编号范围。',
        p_zone_n: '{n} 区',
        p_area: '区域',
        p_prefix: '前缀',
        p_start: '起始',
        p_end: '结束',
        p_start_short: '起始号',
        p_end_short: '结束号',
        p_count: '数量',
        p_none: '（无）',
        p_add_row: '添加行',
        p_total: '合计',
        p_min_max: '每行最少 {min}，最多 {max}',
        p_unit_rooms: '间房',
        p_unit_fields: '个场地',
        p_unit_seats: '个座位',
        p_unit_tables: '张桌',
        p_range_unset: '未设置编号范围',
        p_quantity: '数量',
        p_number_range: '编号范围',
        p_add_area: '添加区域',
        p_rooms_to_create: '将创建的房间数',
        p_fields_to_create: '将创建的场地数',
        p_seats_to_create: '将创建的座位数',
        p_tables_to_create: '将创建的桌数',
        p_name_required: '请输入名称',
        p_name_too_long: '名称过长（≤ 250）',
        p_price_invalid: '价格无效',
        p_add_or_skip: '请至少添加 1 行或跳过',
        p_samples_added: '已添加 {n} 个示例商品。请在继续前检查。',
        p_rate_limit: '操作过于频繁，请稍等一分钟。',
        p_ai_quota: 'AI 额度已用完或服务商暂不可用。',
        p_sample_failed: '无法生成示例数据，请重试。',
        p_file_too_large: '文件过大（最大 10MB）',
        p_image_too_large: '有文件超出限制（图片最大 10 MB）。请选择较小的文件。',
        p_file_unsupported: '仅支持图片 / PDF / Excel / CSV',
        p_ai_read_failed: 'AI 无法读取，请手动输入或换一个文件',
        p_ai_empty_plan: 'AI 未能提取内容，请换更清晰的文件',
        p_ai_disabled: 'AI 功能尚未配置',
        p_col_name: '商品名称',
        p_col_group: '分组',
        p_col_price: '售价',
        p_drop_products: '拖放文件（图片 / PDF / Excel / Word / CSV，≤ 10MB）— AI 将读取并添加到列表',
        p_drop_slots: '拖放价目表（图片 / PDF / Excel / CSV，≤ 10MB）— AI 将提取时段',
        p_reading_file: '正在读取文件…',
        p_pick_file: '或点击选择文件',
        p_sample: '生成示例数据',
        p_sample_hint: '示例数据可帮助您试用功能，之后可以清理。',
        p_generating: '正在生成示例数据…',
        p_sample_images: '示例商品图片将在保存后生成。',
        p_items_added: '已添加 {n} 个新项目。',
        p_items_added_skipped: '已添加 {n} 个新项目，跳过 {m} 个已有项目。',
        p_added_to_list: '已将 {name} 添加到列表。',
        p_act_add: '添加',
        p_act_camera: '拍照',
        p_act_gallery: '相册',
        p_act_text: '文本',
        p_act_device: '设备',
        p_review_ai: '检查 AI 结果',
        p_items_found: '找到 {n} 个项目',
        p_menu: '菜单',
        p_all: '全部',
        p_added_badge: '已添加',
        p_confirm_add: '确认添加',
        p_auto_images: '自动生成商品图片',
        p_slot_code_required: '请输入时段代码',
        p_hour_invalid: '时间无效（HH:MM:SS）',
        p_hour_range: '结束时间必须晚于开始时间',
        p_col_code: '代码',
        p_col_slot_name: '名称',
        p_col_start: '开始时间',
        p_col_end: '结束时间',
        p_col_weekday: '平日价',
        p_col_weekend: '周末价',
        p_add_slot: '添加时段',
        p_currency: '货币'
    },
    ko: {
        cta_back: '뒤로', cta_continue: '계속', loading: '처리 중...', error_generic: '오류가 발생했습니다',
        apply_failed: '설정을 적용할 수 없습니다. 선택 내용은 저장되었습니다.', retry: '다시 시도', logout: '로그아웃',
        progress_question: '질문', question_eyebrow: '빠른 설정', answer_yes: '예', answer_no: '아니요',
        feature_label: '기능',
        identity_industry: '업종',
        cta_skip: '건너뛰기',
        detail_toggle: '어떤 것을 선택할까요?',
        detail_changeable: '설정에서 언제든지 변경할 수 있습니다.',
        need_answer: '계속하려면 답을 선택하세요',
        areas_need_row: '한 줄 이상 추가하거나 아니요를 선택하세요.',
        areas_need_valid: '유효한 줄을 한 개 이상 추가하세요.',
        list_rooms: '방 목록',
        list_fields: '코트 목록',
        list_seats: '좌석 목록',
        list_table_areas: '테이블 구역',
        create_rooms: '방 만들기',
        create_fields: '코트 만들기',
        create_tables: '테이블 만들기',
        cta_confirm: '확인',
        areas_need_area: '유효한 구역을 한 개 이상 추가하세요.',
        p_area_name_required: '구역 이름을 입력하세요',
        p_prefix_required: '접두사를 입력하세요',
        p_start_min: '시작 번호는 ≥ 1이어야 합니다',
        p_end_min: '끝 번호는 ≥ 시작 번호여야 합니다',
        p_count_range: '수량은 {min}~{max} 사이여야 합니다',
        p_range_overlap: '번호 범위가 다른 행과 겹칩니다 (같은 접두사)',
        p_range_invalid: '올바른 번호 범위를 입력하세요.',
        p_zone_n: '{n} 구역',
        p_area: '구역',
        p_prefix: '접두사',
        p_start: '시작',
        p_end: '끝',
        p_start_short: '시작 번호',
        p_end_short: '끝 번호',
        p_count: '수량',
        p_none: '(없음)',
        p_add_row: '행 추가',
        p_total: '합계',
        p_min_max: '행당 최소 {min}, 최대 {max}',
        p_unit_rooms: '개 룸',
        p_unit_fields: '개 코트',
        p_unit_seats: '개 좌석',
        p_unit_tables: '개 테이블',
        p_range_unset: '번호 범위 미설정',
        p_quantity: '수량',
        p_number_range: '번호 범위',
        p_add_area: '구역 추가',
        p_rooms_to_create: '생성할 룸 수',
        p_fields_to_create: '생성할 코트 수',
        p_seats_to_create: '생성할 좌석 수',
        p_tables_to_create: '생성할 테이블 수',
        p_name_required: '이름을 입력하세요',
        p_name_too_long: '이름이 너무 깁니다 (≤ 250)',
        p_price_invalid: '가격이 올바르지 않습니다',
        p_add_or_skip: '1개 이상의 행을 추가하거나 건너뛰세요',
        p_samples_added: '샘플 상품 {n}개를 추가했습니다. 계속하기 전에 확인해 주세요.',
        p_rate_limit: '요청이 너무 많습니다. 1분 후 다시 시도해 주세요.',
        p_ai_quota: 'AI 사용 한도가 소진되었거나 제공업체를 사용할 수 없습니다.',
        p_sample_failed: '샘플 데이터를 생성하지 못했습니다. 다시 시도해 주세요.',
        p_file_too_large: '파일이 너무 큽니다 (최대 10MB)',
        p_image_too_large: '허용 한도를 초과한 파일이 있습니다 (이미지 최대 10 MB). 더 작은 파일을 선택해 주세요.',
        p_file_unsupported: '이미지 / PDF / Excel / CSV만 지원합니다',
        p_ai_read_failed: 'AI가 읽지 못했습니다. 직접 입력하거나 다른 파일을 사용해 주세요',
        p_ai_empty_plan: 'AI가 추출하지 못했습니다. 더 선명한 파일을 사용해 주세요',
        p_ai_disabled: 'AI 기능이 설정되지 않았습니다',
        p_col_name: '상품명',
        p_col_group: '그룹',
        p_col_price: '판매가',
        p_drop_products: '파일을 끌어다 놓으세요 (이미지 / PDF / Excel / Word / CSV, ≤ 10MB) — AI가 읽어 목록에 추가합니다',
        p_drop_slots: '가격표를 끌어다 놓으세요 (이미지 / PDF / Excel / CSV, ≤ 10MB) — AI가 시간대를 추출합니다',
        p_reading_file: '파일 읽는 중…',
        p_pick_file: '또는 클릭하여 파일 선택',
        p_sample: '샘플 데이터 생성',
        p_sample_hint: '샘플 데이터로 기능을 체험해 볼 수 있으며, 나중에 정리할 수 있습니다.',
        p_generating: '샘플 데이터 생성 중…',
        p_sample_images: '샘플 상품 이미지는 저장 후 생성됩니다.',
        p_items_added: '새 항목 {n}개를 추가했습니다.',
        p_items_added_skipped: '새 항목 {n}개를 추가하고, 기존 항목 {m}개는 건너뛰었습니다.',
        p_added_to_list: '{name}을(를) 목록에 추가했습니다.',
        p_act_add: '추가',
        p_act_camera: '촬영',
        p_act_gallery: '사진',
        p_act_text: '텍스트',
        p_act_device: '기기',
        p_review_ai: 'AI 결과 확인',
        p_items_found: '{n}개 항목 찾음',
        p_menu: '메뉴',
        p_all: '전체',
        p_added_badge: '추가됨',
        p_confirm_add: '추가 확인',
        p_auto_images: '상품 이미지 자동 생성',
        p_slot_code_required: '시간대 코드를 입력하세요',
        p_hour_invalid: '시간이 올바르지 않습니다 (HH:MM:SS)',
        p_hour_range: '종료 시간은 시작 시간 이후여야 합니다',
        p_col_code: '코드',
        p_col_slot_name: '이름',
        p_col_start: '시작 시간',
        p_col_end: '종료 시간',
        p_col_weekday: '평일 요금',
        p_col_weekend: '주말 요금',
        p_add_slot: '시간대 추가',
        p_currency: '통화'
    },
    hi: {
        cta_back: 'वापस', cta_continue: 'जारी रखें', loading: 'प्रक्रिया जारी...', error_generic: 'एक त्रुटि हुई',
        apply_failed: 'कॉन्फ़िगरेशन लागू नहीं हो सका। आपके चयन सुरक्षित हैं।', retry: 'फिर प्रयास करें', logout: 'साइन आउट',
        progress_question: 'प्रश्न', question_eyebrow: 'त्वरित सेटअप', answer_yes: 'हाँ', answer_no: 'नहीं',
        feature_label: 'सुविधा',
        identity_industry: 'उद्योग',
        cta_skip: 'छोड़ें',
        detail_toggle: 'क्या चुनें?',
        detail_changeable: 'इसे सेटिंग्स में कभी भी बदला जा सकता है।',
        need_answer: 'जारी रखने के लिए एक उत्तर चुनें',
        areas_need_row: 'कम से कम एक पंक्ति जोड़ें, या नहीं चुनें।',
        areas_need_valid: 'कम से कम एक मान्य पंक्ति जोड़ें।',
        list_rooms: 'कमरों की सूची',
        list_fields: 'कोर्ट की सूची',
        list_seats: 'सीटों की सूची',
        list_table_areas: 'टेबल क्षेत्र',
        create_rooms: 'कमरे बनाएँ',
        create_fields: 'कोर्ट बनाएँ',
        create_tables: 'टेबल बनाएँ',
        cta_confirm: 'पुष्टि करें',
        areas_need_area: 'कम से कम एक मान्य क्षेत्र जोड़ें।',
        p_area_name_required: 'एरिया का नाम ज़रूरी है',
        p_prefix_required: 'प्रीफ़िक्स ज़रूरी है',
        p_start_min: 'शुरुआती नंबर ≥ 1 होना चाहिए',
        p_end_min: 'आख़िरी नंबर ≥ शुरुआती नंबर होना चाहिए',
        p_count_range: 'संख्या {min} से {max} के बीच होनी चाहिए',
        p_range_overlap: 'नंबर रेंज दूसरी पंक्ति से टकरा रही है (वही प्रीफ़िक्स)',
        p_range_invalid: 'कृपया सही नंबर रेंज दर्ज करें।',
        p_zone_n: 'ज़ोन {n}',
        p_area: 'एरिया',
        p_prefix: 'प्रीफ़िक्स',
        p_start: 'शुरू',
        p_end: 'अंत',
        p_start_short: 'पहला नं.',
        p_end_short: 'आख़िरी नं.',
        p_count: 'संख्या',
        p_none: '(कोई नहीं)',
        p_add_row: 'पंक्ति जोड़ें',
        p_total: 'कुल',
        p_min_max: 'प्रति पंक्ति न्यूनतम {min}, अधिकतम {max}',
        p_unit_rooms: 'कमरे',
        p_unit_fields: 'कोर्ट',
        p_unit_seats: 'सीटें',
        p_unit_tables: 'टेबल',
        p_range_unset: 'नंबर रेंज सेट नहीं है',
        p_quantity: 'मात्रा',
        p_number_range: 'नंबर रेंज',
        p_add_area: 'एरिया जोड़ें',
        p_rooms_to_create: 'बनने वाले कमरे',
        p_fields_to_create: 'बनने वाले कोर्ट',
        p_seats_to_create: 'बनने वाली सीटें',
        p_tables_to_create: 'बनने वाली टेबल',
        p_name_required: 'नाम ज़रूरी है',
        p_name_too_long: 'नाम बहुत लंबा है (≤ 250)',
        p_price_invalid: 'कीमत सही नहीं है',
        p_add_or_skip: 'कम से कम 1 पंक्ति जोड़ें या छोड़ दें',
        p_samples_added: '{n} सैंपल प्रोडक्ट जोड़े गए। आगे बढ़ने से पहले जाँच लें।',
        p_rate_limit: 'बहुत ज़्यादा अनुरोध। कृपया एक मिनट रुकें।',
        p_ai_quota: 'AI की सीमा समाप्त हो गई है या प्रदाता अभी उपलब्ध नहीं है।',
        p_sample_failed: 'सैंपल डेटा नहीं बन सका। कृपया फिर से कोशिश करें।',
        p_file_too_large: 'फ़ाइल बहुत बड़ी है (अधिकतम 10MB)',
        p_image_too_large: 'एक फ़ाइल तय सीमा से बड़ी है (इमेज के लिए अधिकतम 10 MB)। कृपया छोटी फ़ाइल चुनें।',
        p_file_unsupported: 'केवल इमेज / PDF / Excel / CSV समर्थित हैं',
        p_ai_read_failed: 'AI इसे पढ़ नहीं सका, कृपया खुद दर्ज करें या दूसरी फ़ाइल आज़माएँ',
        p_ai_empty_plan: 'AI कुछ निकाल नहीं सका, ज़्यादा साफ़ फ़ाइल आज़माएँ',
        p_ai_disabled: 'AI सुविधा कॉन्फ़िगर नहीं है',
        p_col_name: 'प्रोडक्ट का नाम',
        p_col_group: 'ग्रुप',
        p_col_price: 'बिक्री मूल्य',
        p_drop_products: 'फ़ाइल यहाँ छोड़ें (इमेज / PDF / Excel / Word / CSV, ≤ 10MB) — AI इसे पढ़कर सूची में जोड़ देगा',
        p_drop_slots: 'रेट लिस्ट यहाँ छोड़ें (इमेज / PDF / Excel / CSV, ≤ 10MB) — AI टाइम स्लॉट निकाल लेगा',
        p_reading_file: 'फ़ाइल पढ़ी जा रही है…',
        p_pick_file: 'या फ़ाइल चुनने के लिए क्लिक करें',
        p_sample: 'सैंपल डेटा बनाएँ',
        p_sample_hint: 'सैंपल डेटा से आप सुविधाएँ आज़मा सकते हैं। इसे बाद में हटाया जा सकता है।',
        p_generating: 'सैंपल डेटा बन रहा है…',
        p_sample_images: 'सैंपल प्रोडक्ट इमेज सेव करने के बाद बनती हैं।',
        p_items_added: '{n} नए आइटम जोड़े गए।',
        p_items_added_skipped: '{n} नए आइटम जोड़े गए, {m} मौजूदा आइटम छोड़े गए।',
        p_added_to_list: '{name} सूची में जोड़ा गया।',
        p_act_add: 'जोड़ें',
        p_act_camera: 'कैमरा',
        p_act_gallery: 'गैलरी',
        p_act_text: 'टेक्स्ट',
        p_act_device: 'डिवाइस',
        p_review_ai: 'AI के नतीजे जाँचें',
        p_items_found: '{n} आइटम मिले',
        p_menu: 'मेनू',
        p_all: 'सभी',
        p_added_badge: 'जोड़ा गया',
        p_confirm_add: 'पुष्टि करके जोड़ें',
        p_auto_images: 'प्रोडक्ट इमेज अपने-आप बनाएँ',
        p_slot_code_required: 'टाइम स्लॉट कोड ज़रूरी है',
        p_hour_invalid: 'समय सही नहीं है (HH:MM:SS)',
        p_hour_range: 'समाप्ति समय शुरू के समय के बाद होना चाहिए',
        p_col_code: 'कोड',
        p_col_slot_name: 'नाम',
        p_col_start: 'शुरू का समय',
        p_col_end: 'समाप्ति समय',
        p_col_weekday: 'सामान्य कीमत',
        p_col_weekend: 'वीकेंड कीमत',
        p_add_slot: 'टाइम स्लॉट जोड़ें',
        p_currency: 'मुद्रा'
    },
    ar: {
        cta_back: 'رجوع', cta_continue: 'متابعة', loading: 'جارٍ المعالجة...', error_generic: 'حدث خطأ',
        apply_failed: 'تعذر تطبيق الإعداد. تم الاحتفاظ باختياراتك.', retry: 'إعادة المحاولة', logout: 'تسجيل الخروج',
        progress_question: 'السؤال', question_eyebrow: 'إعداد سريع', answer_yes: 'نعم', answer_no: 'لا',
        feature_label: 'الميزة',
        identity_industry: 'القطاع',
        cta_skip: 'تخطي',
        detail_toggle: 'أيهما أختار؟',
        detail_changeable: 'يمكنك تغيير ذلك في أي وقت من الإعدادات.',
        need_answer: 'اختر إجابة للمتابعة',
        areas_need_row: 'أضف صفًا واحدًا على الأقل، أو اختر لا.',
        areas_need_valid: 'أضف صفًا صالحًا واحدًا على الأقل.',
        list_rooms: 'قائمة الغرف',
        list_fields: 'قائمة الملاعب',
        list_seats: 'قائمة المقاعد',
        list_table_areas: 'مناطق الطاولات',
        create_rooms: 'إنشاء الغرف',
        create_fields: 'إنشاء الملاعب',
        create_tables: 'إنشاء الطاولات',
        cta_confirm: 'تأكيد',
        areas_need_area: 'أضف منطقة صالحة واحدة على الأقل.',
        p_area_name_required: 'اسم المنطقة مطلوب',
        p_prefix_required: 'البادئة مطلوبة',
        p_start_min: 'رقم البداية يجب أن يكون ≥ 1',
        p_end_min: 'رقم النهاية يجب أن يكون ≥ رقم البداية',
        p_count_range: 'يجب أن يكون العدد بين {min} و{max}',
        p_range_overlap: 'النطاق يتداخل مع صف آخر (البادئة نفسها)',
        p_range_invalid: 'يرجى إدخال نطاق أرقام صالح.',
        p_zone_n: 'المنطقة {n}',
        p_area: 'المنطقة',
        p_prefix: 'البادئة',
        p_start: 'البداية',
        p_end: 'النهاية',
        p_start_short: 'أول رقم',
        p_end_short: 'آخر رقم',
        p_count: 'العدد',
        p_none: '(لا يوجد)',
        p_add_row: 'إضافة صف',
        p_total: 'الإجمالي',
        p_min_max: 'الحد الأدنى {min}، الحد الأقصى {max} لكل صف',
        p_unit_rooms: 'غرفة',
        p_unit_fields: 'ملعب',
        p_unit_seats: 'مقعد',
        p_unit_tables: 'طاولة',
        p_range_unset: 'لم يُحدَّد نطاق الأرقام',
        p_quantity: 'الكمية',
        p_number_range: 'نطاق الأرقام',
        p_add_area: 'إضافة منطقة',
        p_rooms_to_create: 'عدد الغرف المراد إنشاؤها',
        p_fields_to_create: 'عدد الملاعب المراد إنشاؤها',
        p_seats_to_create: 'عدد المقاعد المراد إنشاؤها',
        p_tables_to_create: 'عدد الطاولات المراد إنشاؤها',
        p_name_required: 'الاسم مطلوب',
        p_name_too_long: 'الاسم طويل جدًا (≤ 250)',
        p_price_invalid: 'السعر غير صالح',
        p_add_or_skip: 'أضف صفًا واحدًا على الأقل أو تخطَّ',
        p_samples_added: 'تمت إضافة {n} منتج تجريبي. يرجى المراجعة قبل المتابعة.',
        p_rate_limit: 'طلبات كثيرة جدًا. يرجى الانتظار دقيقة.',
        p_ai_quota: 'انتهت حصة الذكاء الاصطناعي أو أن المزوّد غير متاح حاليًا.',
        p_sample_failed: 'تعذّر إنشاء البيانات التجريبية. يرجى المحاولة مرة أخرى.',
        p_file_too_large: 'الملف كبير جدًا (الحد الأقصى 10MB)',
        p_image_too_large: 'يوجد ملف يتجاوز الحد المسموح (10 MB للصور). يرجى اختيار ملف أصغر.',
        p_file_unsupported: 'المدعوم فقط: صورة / PDF / Excel / CSV',
        p_ai_read_failed: 'تعذّر على الذكاء الاصطناعي قراءة الملف، يرجى الإدخال يدويًا أو تجربة ملف آخر',
        p_ai_empty_plan: 'تعذّر على الذكاء الاصطناعي استخراج البيانات، جرّب ملفًا أوضح',
        p_ai_disabled: 'ميزة الذكاء الاصطناعي غير مهيأة',
        p_col_name: 'اسم المنتج',
        p_col_group: 'المجموعة',
        p_col_price: 'سعر البيع',
        p_drop_products: 'اسحب ملفًا وأفلته هنا (صورة / PDF / Excel / Word / CSV، ≤ 10MB) — سيقرؤه الذكاء الاصطناعي ويضيفه إلى القائمة',
        p_drop_slots: 'اسحب قائمة الأسعار وأفلتها هنا (صورة / PDF / Excel / CSV، ≤ 10MB) — سيستخرج الذكاء الاصطناعي الفترات الزمنية',
        p_reading_file: 'جارٍ قراءة الملف…',
        p_pick_file: 'أو انقر لاختيار ملف',
        p_sample: 'إنشاء بيانات تجريبية',
        p_sample_hint: 'البيانات التجريبية تساعدك على تجربة الميزات، ويمكنك حذفها لاحقًا.',
        p_generating: 'جارٍ إنشاء البيانات التجريبية…',
        p_sample_images: 'تُنشأ صور المنتجات التجريبية بعد الحفظ.',
        p_items_added: 'تمت إضافة {n} عنصر جديد.',
        p_items_added_skipped: 'تمت إضافة {n} عنصر جديد، وتخطي {m} عنصر موجود.',
        p_added_to_list: 'تمت إضافة {name} إلى القائمة.',
        p_act_add: 'إضافة',
        p_act_camera: 'الكاميرا',
        p_act_gallery: 'الصور',
        p_act_text: 'نص',
        p_act_device: 'الجهاز',
        p_review_ai: 'مراجعة نتائج الذكاء الاصطناعي',
        p_items_found: 'تم العثور على {n} عنصر',
        p_menu: 'قائمة الطعام',
        p_all: 'الكل',
        p_added_badge: 'تمت الإضافة',
        p_confirm_add: 'تأكيد الإضافة',
        p_auto_images: 'إنشاء صور المنتجات تلقائيًا',
        p_slot_code_required: 'رمز الفترة الزمنية مطلوب',
        p_hour_invalid: 'الوقت غير صالح (HH:MM:SS)',
        p_hour_range: 'وقت النهاية يجب أن يكون بعد وقت البداية',
        p_col_code: 'الرمز',
        p_col_slot_name: 'الاسم',
        p_col_start: 'وقت البداية',
        p_col_end: 'وقت النهاية',
        p_col_weekday: 'السعر العادي',
        p_col_weekend: 'سعر نهاية الأسبوع',
        p_add_slot: 'إضافة فترة زمنية',
        p_currency: 'العملة'
    }
};

export function t(locale, key) {
    return (strings[locale] && strings[locale][key]) || strings.en[key] || key;
}

// t() cho chuỗi có tham số dạng {ten}.
export function tf(locale, key, params) {
    return t(locale, key).replace(/\{(\w+)\}/g, function (m, name) {
        return params && params[name] !== undefined ? params[name] : m;
    });
}

export default strings;
